module.exports = __webpack_public_path__ + "img/ALDEAO_V2.8faa90ba.jpg";